module.exports = __webpack_public_path__ + "img/sup_deposit_crypto12.97d66cfb.jpg";